import { render } from "./PvP.vue?vue&type=template&id=3a5bfffa"
import script from "./PvP.vue?vue&type=script&lang=js"
export * from "./PvP.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__